import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './deals-feature.component.scss';
var DealsFeature = /** @class */ (function (_super) {
    tslib_1.__extends(DealsFeature, _super);
    function DealsFeature(element) {
        return _super.call(this, element) || this;
    }
    DealsFeature.prototype.init = function () {
    };
    DealsFeature.prototype.bindEvents = function () {
    };
    return DealsFeature;
}(Base));
export { DealsFeature };



//////////////////
// WEBPACK FOOTER
// ./components/deals-feature/deals-feature.component.ts
// module id = 254
// module chunks = 0